import { Helmet } from "react-helmet"

interface CommonPixelProps {
    pixelId?: string|null;
}

export enum Tracker {
    SIGNUP = `signup`,
    DISCOVER = `discover`
}

const CommonPixel = (props: CommonPixelProps) => {
    const { pixelId } = props

    if (pixelId === Tracker.SIGNUP) {
        return (
            <Helmet>
                {/* PLACE SCRIPTS HERE */}
            </Helmet>
        )
    }

    return (
        <>
        </>
    )
}

export default CommonPixel